import React from 'react';
import ReactDOM from 'react-dom';
//
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import './index.css';
import './bootstrap/css/bootstrap.min.css';
//
//import './bootstrap/js/jquery.min.js';
//import './bootstrap/js/bootstrap.js';

import App from './App';
import * as serviceWorker from './serviceWorker';
// Page
import Login from './Login';
import LoginCheck from './LoginCheck';
import Main from './Main';
import Signup from './Signup';
import Detail from './Detail';
import Reset from './Reset';
import OrderComplete from './OrderComplete';
import Selectoption from './Selectoption';
import Stat from './Stat';
import ChangePasswd from './ChangePasswd';
import Board from './Board';
import Boardview from './Boardview';

//<Route path="/Main" exact component={Main} />
ReactDOM.render(

  <Router>
    <div>
      <Route path="/" exact component={Main} />
      <Route path="/Login" component={Login} />
      <Route path="/Signup" component={Signup} />
      <Route path="/Detail" component={Detail} />
      <Route path="/Reset" component={Reset} />
      <Route path="/Option" component={Selectoption} />
      <Route path="/OrderComplete" component={OrderComplete} />
      <Route path="/Stat" component={Stat} />
      <Route path="/ChangePasswd" component={ChangePasswd} />
      <Route path="/Link" component={LoginCheck} />
	  <Route path="/Board/:type" component={Board} />
	  <Route path="/Boardview/:idx" component={Boardview} />
    </div>
  </Router>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
